module.exports = __webpack_public_path__ + "static/media/Abhijeet.6eac6c72.pdf";